import { render, staticRenderFns } from "./EditRoomPrice.vue?vue&type=template&id=2b224452&scoped=true&"
import script from "./EditRoomPrice.vue?vue&type=script&lang=js&"
export * from "./EditRoomPrice.vue?vue&type=script&lang=js&"
import style0 from "./EditRoomPrice.vue?vue&type=style&index=0&id=2b224452&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b224452",
  null
  
)

export default component.exports